import jwtDecode, { JwtPayload } from 'jwt-decode';

interface TokenProps extends JwtPayload {
  exp: number;
  user: {
    email: string;
    id: number;
    company_id: number;
    role: number;
  };
}

interface StoragedJwtProps {
  expired: boolean;
  user: {
    email: string;
    id: number;
    company_id: number;
    role: number;
  };
}

export function useStoragedJwt(
  key = 'precautionary-token'
): StoragedJwtProps | null {
  const jwtToken = localStorage.getItem(key);

  if (!jwtToken) {
    return null;
  }

  const decoded = jwtDecode<TokenProps>(jwtToken);
  const expirationTime = decoded.exp;
  const now = new Date().getTime() / 1000;
  const expired = now > expirationTime;

  const storagedData = {
    expired,
    user: decoded.user,
  };

  return storagedData;
}
